import React, { useRef, useEffect, useState } from 'react';

const VideoThumbnail = ({ width, height, videoFilePath }:any) => {
    const videoRef = useRef(null as any);
    const canvasRef = useRef(null as any);
    const [thumbnail, setThumbnail] = useState(null as any);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        // Capture a still image once the video has seeked to the desired position
        const captureImage = () => {
            const aspectRatio = video.videoWidth / video.videoHeight;
            let scaledWidth = width;
            let scaledHeight = height;
            if (aspectRatio > 1) {
                scaledHeight = Math.floor(width / aspectRatio);
            } else {
                scaledWidth = Math.floor(height * aspectRatio);
            }
            canvas.width = scaledWidth;
            canvas.height = scaledHeight;
            ctx.drawImage(
                video,
                0,
                0,
                video.videoWidth,
                video.videoHeight,
                0,
                0,
                scaledWidth,
                scaledHeight
            );
            setThumbnail(canvas.toDataURL());
            setIsLoading(false);
        };

        // Load the video and seek to the first frame
        const handleLoadedMetadata = () => {
            video.currentTime = 0;
            video.addEventListener('seeked', captureImage, { once: true });
        };

        video.addEventListener('loadedmetadata', handleLoadedMetadata, { once: true });
        video.src = videoFilePath;

        // Cleanup event listeners on unmount
        return () => {
            video.removeEventListener('loadedmetadata', handleLoadedMetadata);
            video.removeEventListener('seeked', captureImage);
        };
    }, [width, height]);

    return (
        <div style={{ width, height, overflow: 'hidden' }}>
          {isLoading ? (
              <div style={{ width: '100%', height: '100%', backgroundColor: 'gray' }}>
                {/* Placeholder image or loading spinner */}
              </div>
          ) : (
              <img src={thumbnail} alt="Thumbnail" style={{ width: '100%', height: 'auto' }} />
          )}
          <video ref={videoRef} crossOrigin="anonymous" style={{ display: 'none' }} />
          <canvas ref={canvasRef} style={{ display: 'none' }} />
        </div>
    );
};

export default VideoThumbnail;
